import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, Store } from '@ngxs/store';

import { ApiPMSEmailTemplateService } from '../services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

import { CreateEmailTemplate, CreatePMSEmailTemplate, DeleteEmailTemplate, GetEmailTemplatesByPartnerId, GetPMSEmailTemplate, GetPMSEmailTemplatesByPartnerId, UpdateEmailTemplate, UpdatePMSEmailTemplate } from '../actions';
import { EmailTemplate, EmailTemplateCreateResponse, PMSEmailTemplate, PMSEmailTemplateCreateResponse } from '../models';
import { tap } from 'rxjs/operators';
export interface PMSEmailTemplateStateModel {
	data: PMSEmailTemplate[] | null;
    emailTemplates: EmailTemplate[] | null;
	loaded: boolean;
}

export const pmsEmailTemplateStateDefaults: PMSEmailTemplateStateModel = {
    data: null,
    emailTemplates: null,
    loaded: false
};

@State<PMSEmailTemplateStateModel>({
	name: 'pmsEmailTemplate',
	defaults: pmsEmailTemplateStateDefaults
})

@Injectable()
export class PMSEmailTemplateState implements NgxsOnInit {


	@Selector()
	static pmsEmailTemplates(state: PMSEmailTemplateStateModel): PMSEmailTemplate[] {
		return state.data!;
	}

	@Selector()
	static emailTemplates(state: PMSEmailTemplateStateModel): EmailTemplate[] {
		return state.emailTemplates!;
	}
	constructor(
    private store: Store,
    private pmsEmailTemplateService: ApiPMSEmailTemplateService,
    private snackbarService: SnackbarService
  ) { }

	ngxsOnInit(): void {
	}
    @Action(GetPMSEmailTemplatesByPartnerId)
	getPMSEmailTemplatesByPartnerId(ctx: StateContext<PMSEmailTemplateStateModel>, action: GetPMSEmailTemplatesByPartnerId) {
    this.pmsEmailTemplateService.getPMSEmailTemplatesByPartnerId(action.partnerId).subscribe(
        (pmsEmailTemplates: PMSEmailTemplate[]) => ctx.patchState({ data: pmsEmailTemplates, loaded: true }));
    }
    @Action(GetPMSEmailTemplate)
	getPMSEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: GetPMSEmailTemplate) {
    this.pmsEmailTemplateService.getPMSEMailTemplate(action.partnerMembershipSubscriptionId).subscribe((pmsEmailTemplate: PMSEmailTemplate[]) => ctx.patchState({ data: pmsEmailTemplate, loaded: true }));
    
    }
    @Action(CreatePMSEmailTemplate)
	createPMSEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: CreatePMSEmailTemplate) {
    this.pmsEmailTemplateService.createPMSEmailTemplate(action.pmsEmailTemplate).subscribe((response: PMSEmailTemplateCreateResponse)=> {
        const data = ctx.getState().data!.slice(0);
        data.push(response.request);
        ctx.patchState({ ...ctx.getState(), data });
    });
	}
    @Action(UpdatePMSEmailTemplate)
    updatePMSEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: UpdatePMSEmailTemplate) {
    this.pmsEmailTemplateService.updatePMSEmailTemplate(action.pmsEmailTemplate).subscribe((pmsEmailTemplate: PMSEmailTemplate)=>{
        const data = ctx.getState().data!.slice(0);
        const index = data.findIndex(e => e.partnerMembershipSubscriptionId === pmsEmailTemplate.partnerMembershipSubscriptionId);
        data[index] = action.pmsEmailTemplate;
        ctx.patchState({ ...ctx.getState(), data });
    }
    );
    }

  @Action(GetEmailTemplatesByPartnerId)
  getEmailTemplatesByPartnerId(ctx: StateContext<PMSEmailTemplateStateModel>, action: GetEmailTemplatesByPartnerId) {
    return this.pmsEmailTemplateService.getEmailTemplatesByPartnerId(action.partnerId).pipe(
      tap((emailTemplates: EmailTemplate[]) => ctx.patchState({ ...ctx.getState(), emailTemplates }))
    );
  }
    @Action(CreateEmailTemplate)
	createEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: CreateEmailTemplate) {
    this.pmsEmailTemplateService.createEmailTemplate(action.emailTemplate).subscribe((response: EmailTemplateCreateResponse) => {
        // TODO: workaround logic only, due to no patch being invoked bug.
        const emailTemplates = ctx.getState().emailTemplates!.slice(0);
        emailTemplates.push(response.request);
        ctx.patchState({ ...ctx.getState(), emailTemplates });
        this.snackbarService.openSnack({ message: 'New email template created!' });
      });
	}
    
    @Action(UpdateEmailTemplate)
    updateEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: UpdateEmailTemplate) {
    this.pmsEmailTemplateService.updateEmailTemplate(action.emailTemplate).subscribe((emailTemplate: EmailTemplate)=>{
        const emailTemplates = ctx.getState().emailTemplates!.slice(0);
        const index = emailTemplates.findIndex(e => e.id === emailTemplate.id);
        emailTemplates[index] = action.emailTemplate;
        ctx.patchState({ ...ctx.getState(), emailTemplates });
        this.snackbarService.openSnack({ message: `Successfully updated!` });
    }
    );
    }
    @Action(DeleteEmailTemplate)
	deleteEmailTemplate(ctx: StateContext<PMSEmailTemplateStateModel>, action: DeleteEmailTemplate) {
    this.pmsEmailTemplateService.deleteEmailTemplate(action.emailTemplateId).subscribe(() => {
      this.store.dispatch(new GetEmailTemplatesByPartnerId(action.partnerId));
      this.snackbarService.openSnack({ message: `Successfully deleted!` });
    });
	}

	




}
